module.exports = __webpack_public_path__ + "img/download.72b9d13d.svg";